import { render, staticRenderFns } from "./PostCategoriesList.vue?vue&type=template&id=288390d8&"
import script from "./PostCategoriesList.vue?vue&type=script&lang=js&"
export * from "./PostCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports